import { useEffect, useState } from "react";

const useCalculateDiscount = (faixa, condicaoEspecial) => {
  const [precoRegraFob, setPrecoRegraFob] = useState(0);
  const [precoRegraCif, setPrecoRegraCif] = useState(0);

  const [precoFinalFob, setPrecoFinalFob] = useState(0);
  const [precoFinalCif, setPrecoFinalCif] = useState(0);

  const [descontoFob, setDescontoFob] = useState(0);
  const [descontoCif, setDescontoCif] = useState(0);

  const [isEditingDesconto, setIsEditingDesconto] = useState(true);
  const [isEditingPrecoFinal, setIsEditingPrecoFinal] = useState(false);

  useEffect(() => {
    if (faixa) {
      setPrecoFinalFob(calculateDiscountFaixa(precoRegraFob, descontoFob));
      setPrecoFinalCif(calculateDiscountFaixa(precoRegraCif, descontoCif));
    } else if (condicaoEspecial) {
      const discountFob = calculateDiscountFobCondicaoEspecial();
      const discountCif = calculateDiscountCifCondicaoEspecial();

      setDescontoFob(discountFob);
      setDescontoCif(discountCif);
    } else {
      setDescontoFob(0);
      setDescontoCif(0);
      setPrecoFinalFob(precoRegraFob);
      setPrecoFinalCif(precoRegraCif);
    }
  }, [faixa, condicaoEspecial, precoRegraFob, precoRegraCif]);

  useEffect(() => {
    if (isEditingPrecoFinal) {
      if (precoRegraFob && precoFinalFob) {
        const discountFob = calculateReverseDiscount(precoRegraFob, precoFinalFob);
        setDescontoFob(discountFob);
      }
      if (precoRegraCif && precoFinalCif) {
        const discountCif = calculateReverseDiscount(precoRegraCif, precoFinalCif);
        setDescontoCif(discountCif);
      }

      // Define desconto -100 se o pre�o final for zero
      if (precoFinalFob === 0 && descontoFob !== 0) {
        setDescontoFob(-100);
      }
      if (precoFinalCif === 0 && descontoCif !== 0) {
        setDescontoCif(-100);
      }
    }
  }, [precoFinalFob, precoFinalCif]);

  useEffect(() => {
    if (isEditingDesconto) {
      setPrecoFinalFob(calculateDiscountFaixa(precoRegraFob, descontoFob));
      setPrecoFinalCif(calculateDiscountFaixa(precoRegraCif, descontoCif));
    }
  }, [descontoFob, descontoCif]);

  const calculateReverseDiscount = (precoRegra, precoFinal) => {
    const percentage = (precoFinal * 100) / precoRegra;
    const discount = percentage < 100 ? (100 - percentage) * -1 : percentage - 100;
    return discount;
  };

  const calculateDiscountFobCondicaoEspecial = () => {
    const percentage = (precoFinalFob * 100) / precoRegraFob;
    const discount = percentage < 100 ? (100 - percentage) * -1 : percentage - 100;
    return discount;
  };

  const calculateDiscountCifCondicaoEspecial = () => {
    const percentage = (precoFinalCif * 100) / precoRegraCif;
    const discount = percentage < 100 ? (100 - percentage) * -1 : percentage - 100;
    return discount;
  };

  const calculateDiscountFaixa = (regra, desconto) => {
    return parseFloat(regra * (1 - (desconto * -1) / 100));
  };

  return {
    precoRegraFob,
    setPrecoRegraFob,
    precoRegraCif,
    setPrecoRegraCif,
    precoFinalFob,
    setPrecoFinalFob,
    precoFinalCif,
    setPrecoFinalCif,
    descontoFob,
    setDescontoFob,
    descontoCif,
    setDescontoCif,
    calculateDiscountFaixa,
    isEditingDesconto,
    setIsEditingDesconto,
    isEditingPrecoFinal,
    setIsEditingPrecoFinal,
  };
};

export default useCalculateDiscount;
